export default {"src":"/_next/static/media/spiritory-logo-white.28e9145c.svg","height":52,"width":254,"blurWidth":0,"blurHeight":0};